import React from "react";
import MainBtn from "./btn/MainBtn"
import { addZeros } from "./utils";
import { WinnerTitle } from "./WinnerTitle";

export default class Header extends React.Component {

  render() {
    let TopContent = this.props.plusPoints 
      ? (<MainBtn inner={"+" + this.props.plusPoints} handleClick={this.props.handleClick}/>)
      : <WinnerTitle/>
      
    return (
      <header className="header" >
        {TopContent}
        <Score 
          score={this.props.score} 
          handleChange={this.props.handleChange}/>
        <WinScore winScore={this.props.winScore}/>
      </header>
    )
  }
}

class Score extends React.Component{
  componentDidUpdate() {
    this.props.handleChange()
  }

  render() {
    return (
      <div className="header__score">
        {addZeros(this.props.score)}
      </div>
    )
  }
}

function WinScore(props) {
  return <div className="winScore">Score for win: <br/>{props.winScore}</div>
}
